import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { routes } from '../../constants/routes'
import { handleSignOut } from '../../actions/auth'

const HomePage = ({ dispatch }) => {
    return (
        <div className="container mt-5">
            <div className="box m-auto w-50">
                <div className="text-center mb-3">
                    <img src="/luna_logo_solo.png" alt="Luna Logo" className="m-auto" width="100" />
                </div>
                <h1 className="text-center mb-5">Luna Leads</h1>
                <p className="text-center mb-5">
                    Welcome to the Luna Leads platform.<br />
                    To get started, <Link to={routes.authLogin}>login</Link>.
                </p>
                <p className="text-center"><Link to={routes.appIndex}>Dashboard</Link></p>
                <p className="text-center">
                    <span className="clickable" onClick={() => dispatch(handleSignOut())}>Sign Out</span>
                </p>
            </div>
        </div>
    )
}

export default connect()(HomePage)
